import axios from 'axios';

const BASE_API = axios.create({
  baseURL: 'https://api-isp.sharktechhub.com/api/v1', //localhost url
  // baseURL: 'http://localhost:3005/api/v1', //localhost url
  // baseURL: 'http://221.120.96.106:3005/api/v1', //server url
  headers: {
    'Content-Type': 'application/json',
  },
});
export default BASE_API;
